// from prosemirror-schema-basic
export var horizontalRule = {
    group: 'block',
    parseDOM: [{ tag: 'hr' }],
    toDOM: function () { return ['hr']; },
};
